import React from 'react'
import './navigation.scss'
import { useAuth } from '../../../customHooks/useAuth'
import { t } from '../../../utils/i18n'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from '../../atoms/button/button'
import { ReactComponent as Back } from '../../../assets/svgs/back-icon.svg'

export const Navigation = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const path = location.pathname.split('/')
  const activeTab =
    path.length <= 2
      ? path[1]
        ? path[1]
        : 'overview'
      : path[1].includes('business-accounts')
        ? 'diagnostic.reporting'
        : path[2]

  const { user } = useAuth()

  const handlePushBack = () => {
    navigate(-1)
  }
  return (
    <nav className="navigation">
      <div className={`nav-left ${path.length > 2 ? 'nav-flex' : ''}`}>
        <div>
          {path.length > 2 && (
            <Button
              ButtonIcon={<Back />}
              removeDefaultCss
              ariaLabel="go-back"
              handleClick={handlePushBack}
            />
          )}
        </div>
        <div>
          <span className="nav-title nav-head">{t(`${activeTab}.title`)}</span>
          <p className="heading-description">{t(`${activeTab}.desc`)}</p>
        </div>
      </div>
      <div className="nav-right">
        {user && (
          <>
            <span className="nav-title nav-head">
              {t('greet.user').replace('{{user}}', user?.name || 'User')}
            </span>
            <p className="heading-description">({user?.email})</p>
          </>
        )}
      </div>
    </nav>
  )
}

export default Navigation
